export class CustomerDropdownResult {
    public id: number = 0;
    public name: string = '';
}
